export const tooltipContainerStyles = {
  backgroundColor: "var(--semantic-color-background-primary)",
  boxShadow: "var(--box-shadow-30)",
  padding: "1.6rem",
  border: "0.1rem solid var(--semantic-color-border-interactive-rest)",
  borderRadius: "0.8rem",
};
